module.exports = "/_next/static/images/7b8bc9fbb0bd88a58373e11d5568731d-close-big.svg";